module.exports = "/_next/static/resources/pack-a9af3409c2b39a5e94e8f5dbafaf9e36.webp";